import React, { useState } from "react";

import FilterContainer from "../../../../components/common/FilterContainer";
import MultiSelect from "../../../../components/common/MultiSelect";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import ConfirmationBox from "../../../../components/common/ConfirmationBox";

import { Propertiesunitscampaigns } from "../../../../data/renewals";
import { emailGuide } from "../../../../data/text";
import { names, ownerEmails } from "../../../../data/people";

import { BsCheckLg } from "react-icons/bs";
import { MdEmail } from "react-icons/md";

import { Button, Checkbox, Col, Form, Input, Row } from "antd";
import TextArea from "antd/es/input/TextArea";

import "./OwnerPortalAnnouncement.css";

const OwnerPortalAnnouncementRightbar = [];

function OwnerPortalAnnouncement() {
  const [checkboxes, setCheckboxes] = useState({});
  const [emailConfirmationBoxOpen, setEmailConfirmationBoxOpen] = useState(false);

  const handleSelectAll = () => {
    const updatedCheckboxes = {};
    ownerEmails.forEach((item) => {
      updatedCheckboxes[item.id] = true;
    });
    setCheckboxes(updatedCheckboxes);
  };

  const handleSelectNone = () => {
    const updatedCheckboxes = {};
    ownerEmails.forEach((item) => {
      updatedCheckboxes[item.id] = false;
    });
    setCheckboxes(updatedCheckboxes);
  };

  return (
    <>
      <div className="owner-portal-announcement">
        <PageHeading heading="Owner Portal Announcement" />
        <Row gutter={[0,24]}>
          <Col span={24}>
            <FilterContainer
              heading={"Select the filters you want and press Search below."}
            >
              <Form
                name="basic"
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                }}
                autoComplete="off"
                colon={false}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item label="Properties">
                      <MultiSelect
                        options={Propertiesunitscampaigns}
                        placeholder="Search by property, group, portfolio or owner"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Button type="primary" htmlType="submit">
                        Search
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </FilterContainer>
          </Col>
          <Col span={24}>
            <Row gutter={[0,16]}>
              <Col span={24}>
                <Row justify="space-between" align="middle">
                  <Col className="flex-container">
                    <BsCheckLg size={18} />{" "}
                    <span className="onclick-text" onClick={handleSelectAll}>
                      All
                    </span>
                    ,{" "}
                    <span className="onclick-text" onClick={handleSelectNone}>
                      None
                    </span>
                  </Col>
                  <Col>
                    <button className="email-btn flex-container" onClick={()=>setEmailConfirmationBoxOpen(true)}>
                      <MdEmail size={18}/>
                      <span>Email</span>
                    </button>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <div className="all-data-container">
                <Row className="col-container">
                  <Col span={4}>
                    <span className="span-container">Email</span>
                  </Col>
                  <Col span={10}>
                    <span className="span-container">Owner</span>
                  </Col>
                  <Col span={10}>
                    <span className="span-container">Last Announcement Email Sent</span>
                  </Col>
                </Row>
                {ownerEmails.map((item, index) => {
                  return (
                    <Row key={index} className="data-container">
                      <Col span={4}>
                        <Checkbox
                          checked={checkboxes[item.id]}
                          onChange={(e) => {
                            const updatedCheckboxes = {
                              ...checkboxes,
                              [item.id]: e.target.checked,
                            };
                            setCheckboxes(updatedCheckboxes);
                          }}
                          className="span-container"
                        ></Checkbox>
                      </Col>
                      <Col span={10}>
                        <span className="span-container">{item.owner}</span>
                      </Col>
                      <Col span={10}>
                        <span className="span-container">{item.lastAnnouncementEmailSent}</span>
                      </Col>
                    </Row>
                  );
                })}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={OwnerPortalAnnouncementRightbar} />
      </div>
      {emailConfirmationBoxOpen ? (
        <ConfirmationBox
          setIsConfirmationBoxOpen={setEmailConfirmationBoxOpen}
        >
          <h2>Send Email</h2>

          <Form layout="vertical" colon={false} className="form-container">
            <Form.Item label="Send BCC to" required>
              <MultiSelect options={names} placeholder="Start typing to search"/>
            </Form.Item>
            <Form.Item label="Email Subject">
             <Input placeholder="Email subject" required/>
            </Form.Item>
            <Form.Item>
                <TextArea rows={14} value={emailGuide} style={{ resize: "none" }}/>
            </Form.Item>
          </Form>

          <div className="action-buttons">
            <Button
              type="primary"
              onClick={() => setEmailConfirmationBoxOpen(false)}
            >
             Send
            </Button>
            <button
              className="cancel-btn"
              onClick={() => setEmailConfirmationBoxOpen(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
    </>
  );
}

export default OwnerPortalAnnouncement;
